import React, { useState } from "react"
import SideBar from "../../components/sidebar/Sidebar"
import "./Beni.scss"
import AddIcon from "@mui/icons-material/Add"
import { Box, Fab, Typography } from "@mui/material"
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket"
import TabellaBene from "../../components/bene/BeneTableComponent"
import ExcelExportButton from "../../components/shared/ExcelExportButton"
import { GridColDef } from "@mui/x-data-grid"
import { useQuery } from "react-query"
import { fetchSelectBeni } from "../../api/beni"
import { fetchBeniQueryKey } from "../../utils/QueryClient"
import { FetchPaginatedApiModel } from "../../models/shared/CommonModels"
import { BeneModelDetailed } from "../../models/BeneModel"

const BenePage: React.FC<{}> = () => {

  const [fabVisible, setFabVisible] = useState(true)
  const [beni, setBeni] = useState<FetchPaginatedApiModel<BeneModelDetailed[]>>(undefined as any)
  
  useQuery({
    queryKey: [fetchBeniQueryKey],
    queryFn: () => fetchSelectBeni(0, undefined, { id: 0, field: "id", direction: "asc" }, -1),
    onSuccess: (getResponse) => {
      setBeni(getResponse.data);
    },
    refetchOnWindowFocus: false,
  });

  const excelColumns: GridColDef[] = [
    { field: "id", headerName: "ID Bene", width: 80 },
    { field: "ubicazione", headerName: "Ubicazione", width: 150 },
    { field: "sotto_tipologia", headerName: "Sotto-Categoria", width: 150 },
    { field: "qualita", headerName: "Stato", width: 120 },
    { field: "brand", headerName: "Brand", width: 150 },
    { field: "contratto", headerName: "Contratto", width: 200 },
    { field: "condizione", headerName: "Condizione", width: 150 },
    { field: "valutazione_min", headerName: "Min Valutazione", width: 120 },
    { field: "valutazione_max", headerName: "Max Valutazione", width: 120 },
    { field: "data_vendita", headerName: "Data Vendita", width: 120 },
    { field: "prezzo_vendita", headerName: "Prz. Vend.", width: 100 },
    { field: "prezzo_netto", headerName: "Prz. Netto", width: 100 },
    { field: "note_vendita", headerName: "Note di Vendita", width: 200 },
  ];

  const excelRows = beni?.data?.map(bene => ({
    id: bene.id,
    ubicazione: bene.ubicazionebene?.nome || "-",
    sotto_tipologia: bene.sottotipologiabene?.nome || "-",
    qualita: bene.qualitabene?.nome || "-",
    brand: bene.brandbene?.nome || "-",
    contratto: bene.benecontratto?.[0]?.contratto?.titolo || "-",
    condizione: bene.benecontratto?.[0]?.condizione?.nome || "-",
    valutazione_min: bene.valutazione_minima + "€",
    valutazione_max: bene.valutazione_massima + "€",
    data_vendita: bene.benecontratto?.[0]?.venditabenecontratto?.data_vendita 
      ? new Date(bene.benecontratto[0].venditabenecontratto.data_vendita).toLocaleDateString("it-IT")
      : "-",
    prezzo_vendita: bene.benecontratto?.[0]?.venditabenecontratto?.totale_lordo !== undefined
      ? bene.benecontratto[0].venditabenecontratto.totale_lordo + "€"
      : "-",
    prezzo_netto: bene.benecontratto?.[0]?.venditabenecontratto?.totale_netto !== undefined
      ? bene.benecontratto[0].venditabenecontratto.totale_netto + "€"
      : "-",
    note_vendita: bene.benecontratto?.[0]?.venditabenecontratto?.selling_notes || "-",
  })) || [];

  return (
    <div className="home">
      {fabVisible &&
        <Fab
          onClick={() => setFabVisible(false)}
          sx={{ position: "fixed", bottom: 16, right: 16 }} color="primary" aria-label="add">
          <AddIcon />
        </Fab>
      }
      <SideBar />
      <div className="homeContainer">
        <Box sx={{ mb: 3 }}>
          <Box sx={{ 
            display: "flex", 
            alignItems: "center", 
            gap: 2,
            mb: 2,
            pb: 2,
            borderBottom: "2px solid",
            borderColor: "primary.main"
          }}>
            <ShoppingBasketIcon sx={{ fontSize: 40, color: "primary.main" }} />
            <Typography 
              variant="h4" 
              sx={{ 
                fontWeight: 600,
                color: "primary.main",
                letterSpacing: "0.5px"
              }}
            >
              Beni
            </Typography>
          </Box>
        </Box>
        <TabellaBene
          alterFabVisibility={setFabVisible}
          fabVisible={fabVisible}
          enableCreate={true}
          anagrafica_cliente_id={-1}
          dettaglio={true} // TODO: verify
          toolbarActions={
            <ExcelExportButton 
              columns={excelColumns}
              rows={excelRows}
            />
          }
        />
      </div>
    </div>
  )
}

export default BenePage
